module.exports = __webpack_public_path__ + "img/diagnocat.903d241b.png";